export default __webpack_public_path__ + "img/eYTVrFtQ.f3ae64bd.svg";